// components/products/ProductsList.tsx
import { Product } from "../../../types/Product";
import TableList, { SelectAction } from "../../ui/TableList";
import ProductRow from "./ProductRow";

interface ProductsListProps {
  products: Product[];
  onAction: (product: Product) => void;
  onSelectProducts?: (selectedProducts: Product[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function ProductsList({
  products,
  onAction,
  onSelectProducts,
  selectable = false,
  selectActions
}: ProductsListProps) {
  const columns = [
    { header: "Produit", className: "w-2/5" },
    { header: "Type", className: "hidden sm:table-cell w-1/6" },
    { header: "Prix", className: "hidden sm:table-cell w-1/6" },
    { header: "Qualité", className: "hidden md:table-cell w-1/6" },
    { header: "Texture", className: "hidden lg:table-cell w-1/6" },
    { header: "Longueur", className: "hidden xl:table-cell w-1/12" },
    { header: "Badge", className: "hidden 2xl:table-cell w-1/12" },
  ];

  return (
    <TableList
      items={products}
      columns={columns}
      getId={(product) => product.id}
      onAction={onAction}
      onSelectItems={onSelectProducts}
      selectable={selectable}
      emptyMessage="Aucun produit trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(product, isSelected, onSelect) => (
        <ProductRow
          key={product.id}
          product={product}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}